class CompareUtils {
  static getCookieName() {
    return 'compare-products-global';
  }

  static getSelectedProducts() {
    try {
      const products = sessionStorage.getItem(this.getCookieName());
      return products ? JSON.parse(products) : [];
    } catch (error) {
      console.warn('Error reading compare products from sessionStorage:', error);
      return [];
    }
  }

  static setSelectedProducts(products) {
    try {
      if (products.length > 0) {
        sessionStorage.setItem(this.getCookieName(), JSON.stringify(products));
      } else {
        sessionStorage.removeItem(this.getCookieName());
      }
    } catch (error) {
      console.warn('Error saving compare products to sessionStorage:', error);
    }
  }

  static getProductsCount() {
    return this.getSelectedProducts().length;
  }

  static isProductInList(productId) {
    const products = this.getSelectedProducts();
    return products.some(product => product.id === productId);
  }

  static addToList(productId, productUrl, productTitle, productImage, productPrice) {
    let products = this.getSelectedProducts();
    const maxProducts = 5;
    
    if (products.length >= maxProducts) {
      return false;
    }

    if (!products.some(product => product.id === productId)) {
      products.push({
        id: productId,
        url: productUrl,
        title: productTitle,
        image: productImage,
        price: productPrice
      });
      
      this.setSelectedProducts(products);
      this.updateCompareCheckboxes();
      this.updateCompareBar();
      this.publishEvent('compare:add', { products, productId });
      return true;
    }
    return false;
  }

  static removeFromList(productId) {
    let products = this.getSelectedProducts();
    products = products.filter(product => product.id !== productId);
    
    this.setSelectedProducts(products);
    this.updateCompareCheckboxes();
    this.updateCompareBar();
    this.publishEvent('compare:remove', { products, productId });
  }

  static clearList() {
    this.setSelectedProducts([]);
    this.updateCompareCheckboxes();
    this.updateCompareBar();
    this.publishEvent('compare:clear', { products: [] });
  }

  static updateCompareCheckboxes() {
    const products = this.getSelectedProducts();
    document.querySelectorAll('.js-compare-checkbox').forEach(checkbox => {
      const productId = checkbox.dataset.productId;
      checkbox.checked = products.some(product => product.id === productId);
    });
  }

  static updateCompareBar() {
    const products = this.getSelectedProducts();
    const compareBar = document.querySelector('.compare-bar');
    const counters = document.querySelectorAll('.compare-bar__counter');
    const compareBtn = document.querySelector('.compare-bar__open');
    
    const desktopSlots = document.querySelectorAll('[data-desktop-slot="true"]');
    const mobileSlots = document.querySelectorAll('[data-mobile-slot="true"]');

    if (!compareBar) return;

    counters.forEach(counter => {
      counter.textContent = products.length;
    });

    const compareButtons = document.querySelectorAll('.compare-bar__open');
    compareButtons.forEach(btn => {
      btn.disabled = products.length < 2;
    });

    desktopSlots.forEach((slot, index) => {
      this.updateSlot(slot, products[index]);
    });

    mobileSlots.forEach((slot, index) => {
      this.updateSlot(slot, products[index]);
    });

    document.querySelectorAll('.slot-remove').forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);
      
      newBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.removeFromList(newBtn.dataset.productId);
      });
    });
  }

  static updateSlot(slot, product) {
    if (product) {
      slot.className = 'compare-slot filled';
      slot.innerHTML = `
        <div class="slot-product">
          <img src="${product.image}" alt="${product.title}" class="slot-image">
          <button class="slot-remove" data-product-id="${product.id}" aria-label="Çıkar">
            <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"></line>
              <line x1="6" y1="6" x2="18" y2="18"></line>
            </svg>
          </button>
        </div>
      `;
    } else {
      slot.className = 'compare-slot empty';
      slot.innerHTML = '';
    }
  }


  static publishEvent(eventName, data) {
    document.dispatchEvent(new CustomEvent(eventName, { detail: data }));
  }
}

class CompareSwitch extends HTMLElement {
  constructor() {
    super();
    
    this.cookieName = 'compare-is-active-global';
    this.classes = {
      isActive: 'is-product-comparing'
    };
    
    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);
  }

  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    try {
      const isActive = localStorage.getItem(this.cookieName) === 'true';
      this.checkboxEl.checked = isActive;
      this.handleChange(isActive);
    } catch (error) {
      console.warn('Error reading compare switch state:', error);
      this.checkboxEl.checked = false;
      this.handleChange(false);
    }
  }

  onChange(evt) {
    evt.preventDefault();
    this.handleChange(this.checkboxEl.checked);
  }

  handleChange(isActive) {
    requestAnimationFrame(() => {
      if (isActive) {
        document.body.classList.add(this.classes.isActive);
      } else {
        document.body.classList.remove(this.classes.isActive);
      }
    });

    CompareUtils.publishEvent('compare:toggle', { isActive });
    
    try {
      localStorage.setItem(this.cookieName, isActive);
    } catch (error) {
      console.warn('Error saving compare switch state:', error);
    }

    this.updateCompareBarVisibility(isActive);
  }

  updateCompareBarVisibility(isActive) {
    const compareBar = document.querySelector('.compare-bar');
    if (compareBar) {
      if (isActive) {
        compareBar.classList.add('compare-bar--visible');
        CompareUtils.updateCompareBar();
      } else {
        compareBar.classList.remove('compare-bar--visible');
      }
    }
  }
}


class CompareCheckbox extends HTMLElement {
  constructor() {
    super();
    
    this.checkboxEl = this.querySelector('input');
    this.onChangeHandler = this.onChange.bind(this);
  }

  connectedCallback() {
    this.init();
    this.checkboxEl.addEventListener('change', this.onChangeHandler);
  }

  disconnectedCallback() {
    this.checkboxEl.removeEventListener('change', this.onChangeHandler);
  }

  init() {
    const { productId } = this.checkboxEl.dataset;
    this.checkboxEl.checked = CompareUtils.isProductInList(productId);
  }

  onChange(evt) {
    evt.preventDefault();
    
    const { 
      productId, 
      productUrl, 
      productTitle, 
      productImage, 
      productPrice 
    } = this.checkboxEl.dataset;

    if (this.checkboxEl.checked) {
      const isAdded = CompareUtils.addToList(
        productId, 
        productUrl, 
        productTitle, 
        productImage, 
        productPrice
      );
      
      if (!isAdded) {
        this.checkboxEl.checked = false;
      }
    } else {
      CompareUtils.removeFromList(productId);
    }
  }
}

customElements.define('compare-switch', CompareSwitch);
customElements.define('compare-checkbox', CompareCheckbox);

document.addEventListener('DOMContentLoaded', () => {
  CompareUtils.updateCompareBar();
  
  document.addEventListener('compare:toggle', (e) => {
  });
  
  document.addEventListener('compare:add', (e) => {
  });
  
  document.addEventListener('compare:remove', (e) => {
  });
});